<template>
  <div :class="{'radio-list': type === 'radio'}"
       class="button-checkboxes">
    <div class="button-checkboxes__list">
      <template v-for="(option, index) in options">
        <div :key="index"
             class="button-checkboxes__item-col">
          <div class="checkbox"
               @click.prevent="onChange(option)"
               :class="getOptionSelector(option)">
            <span class="checkbox__mark">
              <BaseSvg name="ico-check"/>
            </span>
            <span class="checkbox__text">
              {{getOptionLabel(option)}}
            </span>
          </div>
          <slot name="after"
                :index="index"
                :option="option"
                :checked="isChecked(option)">
          </slot>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      options: {
        type: Array,
        default: () => []
      },
      value: {
        type: [String, Number, Object, Array, Boolean]
      },
      textKey: {
        type: String,
        default: 'text'
      },
      type: {
        type: String,
        default: 'checkbox' // 'radio' || 'checkbox'
      },
      compareType: {
        type: String,
        default: 'equal'
      },
      compare: {
        type: Function,
        default: compare
      }
    },
    data() {
      return {}
    },
    computed: {
      computedValue() {
        if (this.type === 'checkbox' && !Array.isArray(this.value)) {
          return []
        }

        return this.value
      },
    },
    methods: {
      isChecked(option) {
        if (this.type === 'radio') {
          return this.compare(this.computedValue, option, this.compareType)
        } else {
          return this.computedValue &&
            this.computedValue.length &&
            !!this.computedValue.find(o => this.compare(o, option, this.compareType))
        }
      },
      onChange(option) {
        let value = this.computedValue
        this.$emit('focus')

        if (this.type === 'radio') {
          this.$emit('input', option)
        } else {
          value = [...value]
          if (this.isChecked(option)) {
            const index = value.findIndex(o => compare(o, option, this.compareType))
            this.$delete(value, index)
          } else {
            value.push(option)
          }

          this.$emit('input', value)
        }
      },
      getOptionLabel(option) {
        if (option instanceof Object) {
          return (option[this.textKey] || '').toString()
        }

        return option
      },
      getOptionSelector(option) {
        const checked = this.isChecked(option)

        // return {
        //   'base-btn--green  _checked': checked,
        //   'base-btn--outline-green': !checked,
        //   '_action': !!option.need_action
        // }
        return {
          '_checked': checked,
          '_action': !!option?.need_action
        }
      }
    }
  }

  function compare(option, option2, compareType) {
    if (compareType === 'id') {
      return option && option2 && option.id === option2.id
    }

    return option === option2
  }
</script>

<style lang="less">

</style>
